module.exports = __webpack_public_path__ + "img/896.a3d971ee.png";